<div class="first-step-area">
  <div class="content-wrapper wrapper-9"
    [ngClass]="{'w-2': role === 'prestataire','wrapper-5': role === 'particulier'}">
    <form class="form-area form b-h gap content" autocomplete="off" [formGroup]="registerFormProvider">


      <div>
        <div class="form-registration">
          <!-- Name fields component -->
          <app-name-fields formControlName="name_fields" [submitted]="submitted">
          </app-name-fields>

          <!-- Email component -->
          <app-email-field formControlName="email" [submitted]="submitted" [externalError]="emailError">
          </app-email-field>

          <!-- Password fields component -->
          <app-password-fields formControlName="password_fields" [submitted]="submitted">
          </app-password-fields>

          <!-- Phone field component -->
          <app-phone-field #phoneField formControlName="phone_field" [submitted]="submitted" [role]="role"
            [required]="true" [usePrefix]="false">
          </app-phone-field>

          <!-- Image field component -->
          @if(role === 'particulier'){
          <app-image-field formControlName="image" [submitted]="submitted" [config]="imageFieldConfig">
          </app-image-field>
          }
          <!-- Prestataire specific fields -->
          <div *ngIf="role === 'prestataire'">
            <!-- Gender field component -->
            <app-gender-field formControlName="gender_field" [submitted]="submitted" [role]="role" [required]="true">
            </app-gender-field>

            <!-- Birthdate field component -->
            <app-birthdate-field formControlName="birthdate_field" [submitted]="submitted" [role]="role"
              [required]="true">
            </app-birthdate-field>

            <!-- Address fields component -->
              <!-- <app-address-fields #addressFields formControlName="address_fields" [submitted]="submitted" [role]="role"
              [required]="true" countryCode="FR">
            </app-address-fields> -->
            <app-progressive-address-fields #addressFields formControlName="address_fields" [submitted]="submitted"
              [role]="role" [required]="true" countryCode="FR">
            </app-progressive-address-fields>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="footer">
    <div class="padding-bloc-btn">
      <app-button *ngIf="role === 'particulier'" [innerText]="'BUTTONS.REGISTER_BTN' | translate" [disabled]="isLoading"
        [loading]="isLoading" (onClick)="submit()"></app-button>
      <button class="btn next-step-btn submit provider" *ngIf="role === 'prestataire'" (click)="nextSteps(2)">
        <span> {{'BUTTONS.CONTINUE' | translate}} </span>
        <img class="country-flag" src="../../../../../../assets/icon/next-step-icn.png" />
      </button>
    </div>
    <div class="t-group" (click)="goToLogin()">
      {{'REGISTER_PAGE.ALREADY_HAVE_ACCOUNT' | translate}}
      <span class="blue-sky">{{'REGISTER_PAGE.CONNECT' | translate}}</span>
    </div>
  </div>
</div>